export const RETAILER_CONNECT_TITLE = 'Retailer Connect';
export const RETAILER_CONNECT_BASE_URL = '/retailer-network';

export const carouselValues = {
  totalNumber: 1240,
  newMembers: 212,
  activeMembers: 32102,
  retentionRate: 37.5,
  transactions: 51822,
  estimatedReimbursement: 12250,
  averageCustomerSavings: 18.4,
  averageMarketBasketSize: 3.75,
};

// Placeholder values to demonstrate delta chips
export const prevCarouselValues = {
  totalNumber: 980,
  newMembers: 198,
  activeMembers: 29000,
  retentionRate: 35.0,
  transactions: 48000,
  estimatedReimbursement: 11000,
  averageCustomerSavings: 17.2,
  averageMarketBasketSize: 3.5,
};
